<template>
    <vs-popup :active.sync="active" :title="title">
        <vs-row>
            <vs-col vs-xs="6" vs-sm="6" vs-lg="6">
                <h5>Date/Time</h5>
            </vs-col>
            <vs-col vs-xs="6" vs-sm="6" vs-lg="6">
                <h5 class="text-right">
                    <FormatText :text="new Date().toISOString()" format="datetime" />
                </h5>
            </vs-col>
        </vs-row>
        <vs-row class="mt-5">
            <vs-col>
                <h5 class="block">Comment</h5>
                <vs-textarea v-model="data.comment" placeholder="Type Here..." />
    
                <small class="block text-danger" v-if="api_errors.comment">
                    {{ api_errors.comment.join(',') }}
                </small>
            </vs-col>
        </vs-row>
        <vs-row class="mt-5">
            <vs-col>
                <vs-button @click="submit(data)">Reject</vs-button>
            </vs-col>
        </vs-row>
    </vs-popup>
</template>

<script>
export default {
    props: {
        is_active: {
            type: Boolean,
            required: true,
            default: false
        },
        submit: {
            type: Function,
            required: true
        },
        api_errors: {
            type: Object,
            default: () => {return {}},
            required: false
        },
        title: {
            type: String,
            default: 'Reject',
            required: false
        }
    },
    data() {
        return {
            active: this.is_active,
            data: {
                comment: null
            }
        }
    },
    watch: {
        active (newV, oldV) {
            if (newV !== oldV) this.$emit('update:is_active', newV)
        },
        is_active (newV, oldV) {
            if (newV !== oldV) this.active = newV
        }
    }
}
</script>